import { render, staticRenderFns } from "./EstruturaWidgetGrafico.vue?vue&type=template&id=2cbc9e1f"
import script from "./EstruturaWidgetGrafico.vue?vue&type=script&lang=js"
export * from "./EstruturaWidgetGrafico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports